import { render, staticRenderFns } from "./CallRecordDetail.vue?vue&type=template&id=b7968054&scoped=true&"
import script from "./CallRecordDetail.vue?vue&type=script&lang=js&"
export * from "./CallRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./CallRecordDetail.vue?vue&type=style&index=0&id=b7968054&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7968054",
  null
  
)

export default component.exports